import React, {Component} from 'react';

export default class Tip extends Component{
    render() {
        return (
            <div className="content">
                <h2 className="title">“创赢联盟”合作声明</h2>
                <p className="cont">中国快递柜行业经过4年规模化市场成长，快递柜已成为消费者接收包裹的主流方式。快递柜公司作为快递公司和电商公司的配套服务商，已成为电商价值链条中重要的一环，未来快递柜对电商物流效率的提升和数据闭环的作用将越来越重要。江苏云柜网络技术有限公司、上海富友电子商务有限公司、深圳中集电商物流科技有限公司作为行业的主流企业，基于共同的经营理念，结成“创赢联盟”，实质性推进行业合作共赢发展，合作主要措施如下：</p>
                <p className="cont">1、三方已在中国主要城市布点60000+个社区，未来12-18个月，三方计划在已有城市范围再优化和新增20000+个社区，届时包裹年处理能力再提升30%，达到年20亿件水平。</p>
                <p className="cont">2、为进一步提升包裹用户体验，改变现有快递末端交付零散无序的局面，同时为实质性提升社区末端交付的效率，降低包裹交付成本，三方将与上游快递物流企业、电商企业全面协作，以统一接入技术标准、统一处理模式，共同与中国主流快递公司完成数据系统深度对接。</p>
                <p className="cont">3、为发挥规模化经营的优势，有效降低运营成本，三方将逐步开放经营资源，包括：共建采购供应商库、共享城市运维人员、共同拓展广告资源、共建社区服务场景等。</p>
                <p className="cont">4、三方将继续研究更深程度合作的方式，同时为建立更为健康有序的行业经营环境，三方不排除吸纳其它快递柜企业进入联盟体系的可能性。</p>
                <div className="right_wrapper">
                    <div className="right_cont">
                        <p>“创赢联盟”成员企业：（排名不分先后）</p>
                        <p>江苏云柜网络技术有限公司</p>
                        <p>上海富友电子商务有限公司</p>
                        <p>深圳中集电商物流科技有限公司</p>
                        <p>2016年10月9日</p>
                    </div>
                </div>
            </div>
        )
    }
}